export default "__VITE_ASSET__0629e5d0__"